// src/components/views/ErrorPage.tsx
import React from "react";
import { useRouteError } from "react-router";

const ErrorPage: React.FC = () => {
    const error = useRouteError();
    let errorMessage = "Unknown error";

    if (error && typeof error === "object" && "message" in error) {
        errorMessage = (error as { message: string }).message;
    } else if (typeof error === "string") {
        errorMessage = error;
    } else if (error) {
        errorMessage = JSON.stringify(error);
    }
    
    return (
        <div>
        <h1>Oops! Something went wrong.</h1>
        <pre>{errorMessage}</pre>
        </div>
    );
};

export default ErrorPage;